export default {
  SET_EVENT(state, eventSelected) {
    state.eventSelected = eventSelected;
  },
  SET_SETTINGS(state, settings) {
    state.settings = settings;
  }
};
